import { useControlContext, isChatOpen } from "../../../control";
import { MessagesProvider } from "../../contexts";
import { ChatOpened } from "./chat-opened";

export const Chat = () => {
  const { chatState } = useControlContext();

  if (isChatOpen(chatState)) {
    return (
      <MessagesProvider>
        <ChatOpened />
      </MessagesProvider>
    );
  }

  return null;
};
